type Report={feature:'call'|'chat';stage:string;conversationId?:number|string;callId?:string};
export function createCmsErrorReporter(send:(payload:Record<string,unknown>)=>Promise<unknown>,uuid=()=>crypto.randomUUID(),now=()=>Date.now()){
 const recent=new Map<string,number>();
 return async(input:Report)=>{
  const conversationId=/^[1-9][0-9]{0,14}$/.test(String(input.conversationId))?String(input.conversationId):undefined;
  const callId=/^[a-zA-Z0-9:_-]{1,100}$/.test(input.callId||'')?input.callId:undefined;
  const stage=['initialize','microphone','start','load_messages','send_message','open_conversation','request','connection','runtime'].includes(input.stage)?input.stage:'runtime';
  const key=JSON.stringify([input.feature,stage,conversationId,callId]);const at=now();if(recent.has(key)&&at-recent.get(key)!<30000)return;
  recent.set(key,at);for(const[k,t]of recent)if(at-t>=30000)recent.delete(k);
  try{await send({feature:input.feature,stage,conversationId,callId,traceId:uuid()})}catch{recent.delete(key);/* Reporting must not block chat/call or report itself recursively. */}
 };
}
